import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from './config';

@Injectable()
export class FrontendIdInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    const cloned = req.clone({
      setHeaders: {
        'x-frontend-id': config.XFrontendId,
        'Authorization': `Bearer ${token}`,
      }
    });
    return next.handle(cloned);
  }
}